import React, {PropTypes} from 'react';

class Welcome extends React.Component {

  constructor () {
    super();
    this.hide = this.hide.bind(this);
    this.autoplay = this.autoplay.bind(this);
  }

  componentDidMount () {
    document.body.addEventListener('mousedown', this.hide, true);
    document.body.addEventListener('touchstart', this.hide, true);

    // Hide welcome if we have a modal to open
    if(window.location.hash) {
      $('.welcome-container').hide();
    }

    // Hack to access Menu's methods from inside the anonymous function bellow
    // where "this" would not work
    let that = this;

    // Hide welcome if some key is pressed, the first time only
    $(document).one("keydown", function(e) {
      if (e.which === 37 || e.which === 39 || e.which === 27){
        that.hide();
      }
      e.preventDefault(); // prevent the default action (scroll / move caret)
    });
  }

  hide () {
    $('.welcome-container').hide();
    clearInterval(this.interval);
  }

  autoplay () {
    this.props.selectionActions.selectNextMonth();
  }

  render() {
    return (
      <div className="welcome-container">
        <div className="welcome">
          <span>Find the best weather</span><br/>
          <span>for your travels</span>
        </div>
      </div>
    );
  }
}

Welcome.propTypes = {
  selection: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired
};

export default Welcome;



/** WEBPACK FOOTER **
 ** ./src/components/Welcome.js
 **/